const Contact = ()=>{
    return <h1> contact information </h1>
}
export default Contact